<template>
  <div>
    <dictionary-table v-show="activeKey===1" ref="list" @getDetail="getDetail"/>
    <dictionary-detail v-show="activeKey===2" ref="detail" @back="back"/>
  </div>
</template>

<script>
import DictionaryTable from '@/views/config/dictionary/DictionaryTable.vue'
import DictionaryDetail from '@/views/config/dictionary/DictionaryDetail.vue'

export default {
  name: 'DictionaryMaintenance',
  components: { DictionaryTable, DictionaryDetail },
  data() {
    return {
      activeKey: 1
    }
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    getDetail(row) {
      this.activeKey = 2
      this.$refs.detail.refresh(row.id)
    }
  }
}
</script>